import React from 'react'
import View from './view.js'

let restrictions = {
  allowedFileTypes: [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
}

export default function Logic(props) {
  return <View viewPath={props.viewPath} restrictions={restrictions} />
}
